<div class="modal-header">
    <h2 class="modal-title">Add Time Entry</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="!processing" [formData]="entity" [colCount]="1" validationGroup="mainValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="created" editorType="dxDateBox" [editorOptions]="{ type: 'date' }" [label]="{ text: 'Date' }">
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="minDate" message="Cannot be less than 10 days ago"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Employee' }" *ngIf="entity">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="entity.employeeId"
                                [items]="employees"
                                valueExpr="id"
                                displayExpr="displayName"
                                searchEnabled="true"
                                showClearButton="true"
                                [readOnly]="!allowEployeeSelection"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item
                        dataField="timeCategoryId"
                        [label]="{ text: 'Type' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{ items: timeCategories, valueExpr: 'id', displayExpr: 'name', showClearButton: true }"
                    >
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>

                    <dxi-item
                        *ngIf="allowJobSelection"
                        dataField="jobId"
                        [label]="{ text: 'Job' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{ items: jobs, valueExpr: 'id', displayExpr: 'jobNumber', showClearButton: true }"
                    >
                    </dxi-item>

                    <dxi-item dataField="quantity" [label]="{ text: 'Duration' }">
                        <dxi-validation-rule type="required" message="Quantity Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="0.25" message="Cannot be less than 0.25"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="note" [label]="{ text: 'Notes' }">
                        <dxi-validation-rule *ngIf="entity.timeCategory?.notesRequired" type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="save()" [hidden]="readOnly">Save</button>
    <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
